import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import {FormattedMessage} from "react-intl";

class NavItem extends Component{

	constructor(){
		super();
		this.state = {
			openClass: 'main-nav__list-item--open'
		}
	}

	handleOnLinkClick = event => {
		if(this.props.type === 'desktop'){
			return;
		}

		this.removeActiveClassFromSiblings(this.listItem.parentNode.childNodes);

		if(!this.listItem.classList.contains(this.state.openClass)){
			this.listItem.classList.add(this.state.openClass);
		}
	};

	handleOnIconClick = event => {
		if(this.props.type === 'desktop'){
			return;
		}

		this.removeActiveClassFromSiblings(this.listItem.parentNode.childNodes);

		this.listItem.classList.toggle(this.state.openClass);
	};

	removeActiveClassFromSiblings = (siblings) => {
		siblings.forEach(node =>{
			if(node !== this.listItem){
				node.classList.remove(this.state.openClass);
			}
		});
	};


	renderSubItems = item => {
		const {localizePath} = this.props;

		if(item.subItems.length <= 0){
			return null;
		}

		return (
			<ul>
				{item.subItems.sort((a,b) => a.code.localeCompare(b.code)).map( subItem => (
						<NavItem key={'item-'+subItem.name.toLowerCase().replace(' ','-')}
						         item={subItem}
						         localizePath={localizePath} />
					))}
			</ul>
		);
	};

	renderIcon = (item, type) => {
		if(item.subItems.length <= 0 || type === "desktop" ){
			return null;
		}

		return (
			<div className="main-nav__icon-container"
			     onClick={this.handleOnIconClick}>
				<i className="fa fa-2x fa-angle-right" />
			</div>
		);
	};

	render(){

		const { item, type, localizePath } = this.props;

		return (
			<li className="main-nav__list-item"  ref={item => this.listItem = item}>
				<div className="main-nav__dropdown">
					<NavLink
						onClick={this.handleOnLinkClick}
						to={localizePath(item.linkTo)}
						activeClassName='active'
						className='main-nav__item'
						exact={item.exact}
						strict={item.strict} >
						<FormattedMessage id={'menu.'+item.name} />
					</NavLink>
					{this.renderIcon(item, type)}
				</div>
				{this.renderSubItems(item)}
			</li>
		);
	}
}

export default NavItem;


// WEBPACK FOOTER //
// ./src/components/common/NavItem.js